import React, {Component} from 'react';
import HTMLReactParser from 'html-react-parser';
class TitleBar extends Component {
  constructor() {
    super();
    this.state = {
      size:  "50px",
    }
  }

  static defaultProps= {
    className:"titlebar",
    color:"#444",
    fontFamily:"Oswald",
    bgc:"rgb(191,215,78)",
    tag:"p",
    styles:{
        textAlign:"center",
        margin:"auto",
        padding:"16px",
        textTransform:"uppercase",
        lineHeight:"24px",
        fontSize:"19px",
        fontWeight:"500",
    },
    divStyle:{
      boxSizing:"border-box",
      borderRadius:"2px",
      boxShadow: "0 2px 2px 0 rgba(0,0,0,0.1)",
      position:"absolute",
      top:"24px",
      left:"24px",
      display:"block",
      maxWidth:" 336px",
    },
    children:"",
    container:"App",
  }
  updateFontSize() {
    let max=50;
    let min=50;
    let pert=.259;
    if(this.props.max && this.props.min){
        max=this.props.max;
        min=this.props.min;
        
    }
    if(this.props.pert){
        pert=this.props.pert;
    }
    let width = 600;
    let new_size  = width*pert;
    if (new_size<max && new_size>min) {
      new_size=new_size+"px";
    } else if (new_size<min) {
      new_size=min+"px";
    } else {
      new_size=max+"px";
    }
    this.setState({ size: new_size });
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateFontSize();
    window.addEventListener("resize", this.updateFontSize.bind(this));
  }

  /**
   * Remove event listener
   */ 
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateFontSize.bind(this));
  }        

  render() {

    const { color, styles, className, fontFamily, children,center } = this.props;
    let divStyle = this.props.divStyle;
    if(center==="1" && window.innerWidth>599){
       divStyle={
        boxSizing:"border-box",
        borderRadius:"2px",
        boxShadow: "0 2px 2px 0 rgba(0,0,0,0.1)",
        position:"absolute",
        top:"24px",
        left:"50%",
         display:"block",
        transform:"translate(-50%,0)",
      }
    }
    return (
        <div style={{...divStyle, backgroundColor:this.props.bgc}} className="titleBlock">
        {(this.props.tag==='h1'?(
            <h1 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h1>
        ):(
            this.props.tag==='h2'?(
            <h2 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h2>
            ):
            this.props.tag==='h3'?(
                <h3 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h3>
            ):
            this.props.tag==='h4'?(
                <h4 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h4>
                ):
                this.props.tag==='h5'?(
                <h5 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h5>
            ):
            this.props.tag==='h6'?(
                <h6 className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </h6>
            ):
            this.props.tag==='p'?(
                <p className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </p>
            ): 
            this.props.tag==='div'?(
                <div className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </div>
            ):
            this.props.tag==='span'?(
                <span className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </span>
            ):
            this.props.tag==='li'?(
                <li className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </li>
            ):
            this.props.tag==='ul'?(
                <ul className={className} style={{fontSize:this.state.size,...styles, color, fontFamily}}>{HTMLReactParser(children)} </ul>
            ):   
        <p className={className} style={{fontSize:this.state.size, ...styles, color, fontFamily}}>{HTMLReactParser(children)} </p>
        
        )
        )}
    </div>
    );
  }
}

export default TitleBar;
